(function () {
  function initLandingVideo(root) {
    var sections = root.querySelectorAll('.new-landing-video-section');
    sections.forEach(function (section) {
      if (section.dataset.videoModalInitialized) return;
      var modal = section.querySelector('[data-video-modal]');
      if (!modal) return;
      var iframe = modal.querySelector('[data-video-modal-iframe]');
      if (!iframe) return;
      section.dataset.videoModalInitialized = 'true';
      var restoreScroll = null;
      var opener = null;

      function lockScroll() {
        var body = document.body;
        var html = document.documentElement;
        var scrollX = window.scrollX;
        var scrollY = window.scrollY;
        var properties = ['position', 'top', 'left', 'right', 'width', 'overflow', 'padding-right'];
        var saved = properties.map(function (name) {
          return [name, body.style.getPropertyValue(name), body.style.getPropertyPriority(name)];
        });
        var htmlOverflow = [html.style.getPropertyValue('overflow'), html.style.getPropertyPriority('overflow')];
        var scrollbar = window.innerWidth - html.clientWidth;
        var padding = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
        body.classList.add('new-landing-video-modal-open');
        html.style.setProperty('overflow', 'hidden');
        body.style.setProperty('position', 'fixed');
        body.style.setProperty('top', -scrollY + 'px');
        body.style.setProperty('left', -scrollX + 'px');
        body.style.setProperty('right', '0');
        body.style.setProperty('width', '100%');
        body.style.setProperty('overflow', 'hidden');
        if (scrollbar > 0) body.style.setProperty('padding-right', padding + scrollbar + 'px');
        restoreScroll = function () {
          saved.forEach(function (entry) {
            if (entry[1]) body.style.setProperty(entry[0], entry[1], entry[2]);
            else body.style.removeProperty(entry[0]);
          });
          if (htmlOverflow[0]) html.style.setProperty('overflow', htmlOverflow[0], htmlOverflow[1]);
          else html.style.removeProperty('overflow');
          body.classList.remove('new-landing-video-modal-open');
          var behavior = [html.style.getPropertyValue('scroll-behavior'), html.style.getPropertyPriority('scroll-behavior')];
          html.style.setProperty('scroll-behavior', 'auto', 'important');
          window.scrollTo(scrollX, scrollY);
          if (behavior[0]) html.style.setProperty('scroll-behavior', behavior[0], behavior[1]);
          else html.style.removeProperty('scroll-behavior');
          restoreScroll = null;
        };
      }

      function openModal(button) {
        if (!modal.hidden) return;
        opener = button;
        // YouTube rel=0 restricts related videos to the same channel; it cannot remove them.
        iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(button.getAttribute('data-video-id')) + '?autoplay=1&rel=0&playsinline=1';
        lockScroll();
        modal.hidden = false;
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-label', 'Video player');
        iframe.setAttribute('title', button.getAttribute('aria-label') || 'Video player');
        modal.querySelector('button[data-video-modal-close]').focus({ preventScroll: true });
      }

      function closeModal() {
        if (modal.hidden) return;
        modal.hidden = true;
        iframe.src = '';
        if (restoreScroll) restoreScroll();
        if (opener && opener.isConnected) opener.focus({ preventScroll: true });
      }

      section.querySelectorAll('[data-video-thumbnail]').forEach(function (button) {
        button.addEventListener('click', function () { openModal(button); });
      });
      modal.querySelectorAll('[data-video-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
      });
      function onKeydown(event) {
        if (event.key === 'Escape' && !modal.hidden) {
          event.preventDefault();
          closeModal();
        }
      }
      document.addEventListener('keydown', onKeydown);
      section.addEventListener('shopify:section:unload', function () {
        closeModal();
        document.removeEventListener('keydown', onKeydown);
      }, { once: true });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initLandingVideo(document); });
  document.addEventListener('shopify:section:load', function (event) {
    initLandingVideo(event.target);
  });
  if (document.readyState !== 'loading') initLandingVideo(document);
})();
